// NPM Imports
import React from "react";

export default function RevvGridText(props) {
  const { row, field } = props;
  const cellValue = row.rowData[field] ? row.rowData[field].cellData : "";
  return <div className="rs-cell">{cellValue}</div>;
}
